import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIClickable from 'UIComponents/button/UIClickable';
import { isNoMatchesOption } from '../utils/useTypeahead';
const EMPTY_OPTION = '__EMPTY_OPTION__';

const FullScreenSearchOption = ({
  option,
  onSelectOption,
  renderOption,
  noMatchesOption
}) => {
  if (option.value === EMPTY_OPTION) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        wordBreak: 'break-word',
        marginTop: '4px'
      },
      children: option.text
    });
  }

  if (isNoMatchesOption(option) && noMatchesOption) {
    return /*#__PURE__*/_jsxs(UIClickable, {
      style: {
        paddingTop: `10px`
      },
      onClick: () => onSelectOption(noMatchesOption),
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          wordBreak: 'break-word',
          marginBottom: '3px'
        },
        children: noMatchesOption.text
      }), noMatchesOption.help && /*#__PURE__*/_jsx("div", {
        style: {
          fontSize: '0.9rem'
        },
        children: noMatchesOption.help
      })]
    });
  }

  return /*#__PURE__*/_jsx(UIClickable, {
    "data-selenium": option.value,
    style: {
      padding: `10px 0 10px`
    },
    onClick: () => onSelectOption(option),
    children: /*#__PURE__*/_jsx("div", {
      style: {
        wordBreak: 'break-word',
        display: 'flex'
      },
      children: !renderOption ? option.text : renderOption(option)
    })
  }, option.value);
};

export default FullScreenSearchOption;